import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Button from '../../../../../components/molecules/buttons';

interface Props {
    isLoading: boolean;
    isEdit: boolean;
}

function PartnersEditBottomButton(props: Props) {
  const { isLoading, isEdit } = props;
  const { partnerId } = useParams();
  const navigation = useNavigate();
  const onNavigateBack = () => navigation(`/partners/${partnerId}`);

  return (
    <div className="d-flex justify-content-end px-4 px-xl-5 pb-4">
      <div style={isEdit ? { width: '200px', marginRight: '20px' } : { display: 'none' }}>
        <Button.Default
          id="cancel"
          type="button"
          label="Cancel"
          size="lg"
          outline
          onClick={onNavigateBack}
        />
      </div>
      <div style={{ width: '200px' }}>
        <Button.Default
          id="save"
          type="submit"
          label="Save Changes"
          size="lg"
          loading={isLoading}
        />
      </div>
    </div>
  );
}

export default React.memo(PartnersEditBottomButton);
